/**
 * Analytics Constants
 *
 * Shared constants for consistent spacing and styling across analytics components.
 */

/**
 * Spacing values used throughout analytics sections
 */
export const ANALYTICS_SPACING = {
  /** Gap between major sections (revenue, clients, etc.) */
  sectionGap: 5,
  /** Gap between stat cards in a row */
  cardGap: 3,
  /** Gap between charts in a row */
  chartGap: 3,
  /** Padding inside section Paper containers */
  sectionPadding: 3,
  /** Space below section titles */
  titleMarginBottom: 3,
  /** Space between stat cards and charts */
  cardsToChartsGap: 4,
};

/**
 * Chart configuration constants
 */
export const CHART_CONFIG = {
  /** Default chart height */
  defaultHeight: 300,
  /** Smaller chart height for compact displays */
  compactHeight: 250,
  /** Grid stroke color */
  gridStroke: '#E5E7EB',
  /** Axis stroke color */
  axisStroke: '#E5E7EB',
};

/**
 * Color palette for charts
 */
export const CHART_COLORS = {
  primary: '#5D5FEF', // Elevair purple
  secondary: '#3B82F6', // Blue
  success: '#10B981', // Green
  warning: '#F59E0B', // Amber
  danger: '#EF4444', // Red
  purple: '#8B5CF6',
  pink: '#EC4899',
  cyan: '#06B6D4',
  teal: '#14B8A6',
  orange: '#F97316',
  lime: '#84CC16',
};

/**
 * Ordered array of chart colors for sequential use
 */
export const CHART_COLOR_SEQUENCE = [
  CHART_COLORS.primary,
  CHART_COLORS.secondary,
  CHART_COLORS.success,
  CHART_COLORS.warning,
  CHART_COLORS.danger,
  CHART_COLORS.purple,
  CHART_COLORS.pink,
  CHART_COLORS.cyan,
  CHART_COLORS.teal,
  CHART_COLORS.orange,
];

/**
 * Status-specific colors for client status charts
 */
export const STATUS_COLORS: Record<string, string> = {
  active: CHART_COLORS.success,
  inactive: '#9CA3AF', // Gray
  lead: CHART_COLORS.secondary,
  archived: '#6B7280', // Dark gray
};
